import { IReminderRepository } from "../../adapters/driven/repositories/reminderRepository";

export type IReminderService = ReturnType<typeof ReminderServiceImplFactory>;

export const ReminderServiceImplFactory = ({
  reminderRepository,
}: {
  reminderRepository: IReminderRepository;
}) => {
  const getReminders = async (payload: {
    clinic_id: number;
    patient_id: number;
  }): IControllerPromiseResponse<IReminder[]> => {
    try {
      const response = await reminderRepository.getReminders(payload);
      return { success: true, data: response?.data ?? [] };
    } catch (error) {
      return { success: false, error };
    }
  };

  const getReminderById = async (payload: {
    clinic_id: number;
    patient_id: number;
    reminder_id: number;
  }): IControllerPromiseResponse<IReminder> => {
    try {
      const response = await reminderRepository.getReminderById(payload);
      return { success: true, data: response?.data };
    } catch (error) {
      return { success: false, error };
    }
  };

  const createReminder = async (
    payload: ICreateReminderPayload
  ): IControllerPromiseResponse<IReminder> => {
    try {
      const response = await reminderRepository.createReminder(payload);
      return { success: true, data: response?.data };
    } catch (error) {
      return { success: false, error };
    }
  };

  const updateReminder = async (payload: {
    clinic_id: number;
    patient_id: number;
    reminder_id: number;
    data: IUpdateReminderPayload;
  }): IControllerPromiseResponse<IReminder> => {
    try {
      const response = await reminderRepository.updateReminder(payload);
      return { success: true, data: response?.data };
    } catch (error) {
      return { success: false, error };
    }
  };

  const deleteReminder = async (payload: {
    clinic_id: number;
    patient_id: number;
    reminder_id: number;
  }): IControllerPromiseResponse<{ message: string }> => {
    try {
      const response = await reminderRepository.deleteReminder(payload);
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error };
    }
  };

  return {
    getReminders,
    getReminderById,
    createReminder,
    updateReminder,
    deleteReminder,
  };
};
